import { Start, Stop } from 'smg/buttons';
import { CreateContact } from 'smg/customer-api/contact';
import { ShowError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import { Phone } from 'smg/phone';
import { Uploader } from 'smg/uploader/v2';
import { Relref } from '../hugo';

main();

function main() {
    const $form = document.querySelector('#contact-form') as HTMLFormElement;
    const $fieldset = $form.querySelector('fieldset') as HTMLFieldSetElement;

    const $name = $form.querySelector('#first-name') as HTMLInputElement;
    const $company = $form.querySelector('#company') as HTMLInputElement;
    const $email = $form.querySelector('#email') as HTMLInputElement;
    const $phone = $form.querySelector('#phone') as HTMLInputElement;
    const $message = $form.querySelector('#message') as HTMLTextAreaElement;
    const $uploadsLabel = $form.querySelector('#uploads') as HTMLLabelElement;
    const $submit = $form.querySelector('[type="submit"]') as HTMLButtonElement;

    const p = new Phone($phone);

    const u = new Uploader({
        $input: $uploadsLabel.querySelector('input[type="file"]') as HTMLInputElement,
        $dropzones: [$uploadsLabel],
        $submitButtons: [$submit],
        $thumbnailsParent: document.querySelector('#uploads-thumbnails') as HTMLElement,
    });

    $form.noValidate = true;
    $form.addEventListener('submit', async e => {
        e.preventDefault();

        if (!ReportValidity($form)) {
            return;
        }

        $fieldset.setAttribute('disabled', 'disabled');
        Start($submit);

        try {
            // allowPartial: the message is the payload; failed attachments were already surfaced
            const uploadIDs = await u.uploadIDs({ allowPartial: true });
            await CreateContact({
                name: $name.value,
                company: $company.value,
                phone: p,
                email: $email.value,
                content: $message.value,
                uploadIDs,
                $reCaptchaPlaceholder: document.querySelector('.contact-recaptcha-parent') as HTMLElement,
            });
            window.location.href = Relref('/submitted');
        } catch (err) {
            ShowError(err);
            $fieldset.removeAttribute('disabled');
            Stop($submit);
        }
    });
}
